import {
  EmrFrequencyKeys,
  EmrFrequencySettingType,
} from 'src/routes/Customers/components/OperatorsTab/modules/types';
import { convertAllEmptyToNull } from 'src/utils/parser';

export const parseEmrSchedullingFrequencyResponse = (
  cronObject: EmrFrequencySettingType,
) => {
  return (
    cronObject &&
    Object.entries(cronObject).reduce(
      (acc: EmrFrequencySettingType, [key, cron]) => {
        acc[key as EmrFrequencyKeys] = cron?.replace(/^0\s+/, '');
        return acc;
      },
      {},
    )
  );
};

export const parseEmrSchedullingFrequencyPayload = (
  cronObject: EmrFrequencySettingType,
) => {
  return (
    cronObject &&
    Object.entries(cronObject).reduce(
      (acc: EmrFrequencySettingType, [key, cron]) => {
        if (!['emrType', 'operatorId'].includes(key)) {
          acc[key as EmrFrequencyKeys] =
            cron && `0 ${cron?.replace(/^\*/, '0')}`;
        }

        return convertAllEmptyToNull(acc);
      },
      {},
    )
  );
};
